export enum VatFrameworkRoute {
  vatFramework = 'current',
  legacy = 'legacy',
  unavailable = 'unavailable',
  dashboards = 'dashboards'
}
